export const serviceActionTypes = {
  SELECTED_ROWS: "SELECTED_ROWS",
  UPDATED_ROWS: "UPDATED_ROWS",
};
